import axios from "axios";
import NhAuth from "nh-auth";
import Vue from "vue";
import VueAxios from "vue-axios";
import Vuex from "vuex";

export default ({ app, store }, inject) => {
  Vue.use(Vuex);
  Vue.use(VueAxios, axios);
  const options = process.env.environment.auth;
  Vue.use(NhAuth, { options, store });
};
